import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import '../../assets/css/styles.css'
import Config from '../../commons/config/Config.js';
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import FormValidation from '../../commons/validation/FormValidation.js'
import Validator from '../../commons/validation/Validator.js'
import Loading from '../ui/Loading.js'
import swal from 'sweetalert'
import {FormattedMessage, injectIntl} from 'react-intl';
import backendStrings from '../../lang/backendStrings.js';
import Notificacion from '../app/Notificacion.js';

// --- DEVOPS FIX: DICCIONARIO DE EMERGENCIA ---
const FALLBACK_MESSAGES = {
    'login.errors.invalido': { id: 'login.errors.invalido', defaultMessage: 'Usuario o contraseña incorrectos.' },
    'login.errors.activar_cuenta': { id: 'login.errors.activar_cuenta', defaultMessage: 'Su usuario se encuentra inactivo. Contacte al administrador.' },
    'login.errors.No_se_encontro_numero_de_telefono_asociado_a_su_usuario': { id: 'login.errors.no_phone', defaultMessage: 'No se encontró celular asociado para 2FA.' },
    'authService.errors.contrasenia_debe_tener_una_longitud_entre': { id: 'auth.pass.len', defaultMessage: 'La contraseña debe tener entre 8 y 16 caracteres.' },
    'errors.internal_server_error': { id: 'error.500', defaultMessage: 'Error interno del servidor.' }
};

class Login extends Component {
    constructor(props) {
        super(props);

        const rawMsg = ConfigBusiness.get("frontend.mantenimiento.mensaje") || props.intl.formatMessage({id: 'login.mantenimiento.mensaje_default', defaultMessage: "Estamos realizando mejoras en el sistema.\nVolveremos a estar operativos a la brevedad."});
        const parsedMsg = rawMsg.replace(/\\n/g, '\n').split('\n');
        const checkInterval = parseInt(ConfigBusiness.get("frontend.mantenimiento.verificarIntervalo")) || 30;

        this.state = {
            formData: { usuario: null, clave: null },
            errors:[], loading: false, redirectTo: null,
            loginEnabled : ConfigBusiness.get("frontend.loginInstancia.habilitado"),
            mantenimientoEnabled: ConfigBusiness.get("frontend.mantenimiento.habilitado"),
            mantenimientoMensaje: parsedMsg,
            mantenimientoFechaFin: ConfigBusiness.get("frontend.mantenimiento.fechaFin"),
            mantenimientoIntervalo: checkInterval,
            mantenimientoTick: checkInterval,
            mantenimientoModo: 'init',
            timezoneDefault: ConfigBusiness.get("frontend.timezoneDefault") || "America/Argentina/Buenos_Aires",
            mantenimientoCountdownStr: "",
            loginServices: {},
            azureLoginRedirect: Config.get('apiUrlBase') + '/public/auth/azure/redirect',
            googleLoginRedirect: Config.get('apiUrlBase') + '/public/auth/google/redirect',
            oktaLoginRedirect: Config.get('apiUrlBase') + '/public/auth/okta/redirect',
            loadingLogoLogin: true, logoLoginUrl: null, languages:[],
            languagesExtra: { "es": "Español", "en": "Inglés" },
            showVersionFull: false, configError: false, retryCountdown: 60,
            isLegacyDomain: false, countdown: 10, focusUser: false, focusPass: false
        }

        this.handleFormChange = this.handleFormChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleForgotPassword = this.handleForgotPassword.bind(this);
        this.loginRandom = null; this.changeLocale = this.changeLocale.bind(this);

        this.mantenimientoController = null;
        this.bgCheckInterval = null;
        this.retryInterval = null;
        this.redirectInterval = null;
    }

    // --- ARQUITECTURA DE 'MARCA BLANCA' ---
    getBrandedLogo(defaultFilename, visibilityConfigKey) {
        if (visibilityConfigKey) {
            const isVisible = ConfigBusiness.get(visibilityConfigKey);
            if (isVisible === "false") return null;
        }
        const clientSlug = ConfigBusiness.get("generales.clienteSlug");
        if (clientSlug && clientSlug !== "false" && clientSlug !== "default") {
            return process.env.PUBLIC_URL + "/images/branding/" + clientSlug + "/" + defaultFilename;
        }
        return process.env.PUBLIC_URL + "/images/company/" + defaultFilename;
    }

    startMantenimientoController = () => {
        const loopFn = () => {
            if (!this.state.mantenimientoFechaFin) return;
            const fechaFin = new Date(this.state.mantenimientoFechaFin).getTime();
            const ahora = new Date().getTime();
            const distancia = fechaFin - ahora;

            if (distancia > 0) {
                if (this.state.mantenimientoModo !== 'countdown') {
                    this.setState({ mantenimientoModo: 'countdown' });
                    if(this.bgCheckInterval) clearInterval(this.bgCheckInterval);
                    this.bgCheckInterval = setInterval(() => window.location.reload(true), 300000);
                }
                const horas = Math.floor(distancia / (1000 * 60 * 60));
                const minutos = Math.floor((distancia % (1000 * 60 * 60)) / (1000 * 60));
                const segundos = Math.floor((distancia % 60000) / 1000);
                this.setState({ mantenimientoCountdownStr: horas + "h " + minutos + "m " + segundos + "s" });
            } else {
                if (this.state.mantenimientoModo !== 'retry') {
                    if(this.bgCheckInterval) clearInterval(this.bgCheckInterval);
                    this.setState({ mantenimientoModo: 'retry', mantenimientoTick: this.state.mantenimientoIntervalo });
                }
                this.setState((prevState) => {
                    let nextTick = prevState.mantenimientoTick - 1;
                    if (nextTick <= 0) {
                        window.location.reload(true);
                        return { mantenimientoTick: prevState.mantenimientoIntervalo };
                    }
                    return { mantenimientoTick: nextTick };
                });
            }
        };

        this.mantenimientoController = setInterval(loopFn, 1000);
        loopFn();
    }

    getEstimatedUptime = () => {
        try {
            if (!this.state.mantenimientoFechaFin) return null;
            const dateObj = new Date(this.state.mantenimientoFechaFin);
            const formatter = new Intl.DateTimeFormat('es-AR', {
                hour: '2-digit', minute: '2-digit', timeZone: this.state.timezoneDefault
            });
            const timeStr = formatter.format(dateObj);
            const city = this.state.timezoneDefault.split('/').pop().replace(/_/g, ' ');
            return "Estimated UpTime " + timeStr + " hs. - " + city;
        } catch (e) { return null; }
    }

    startRetryCountdown = () => {
        if(this.retryInterval) clearInterval(this.retryInterval);
        this.setState({ retryCountdown: 60 });
        this.retryInterval = setInterval(() => {
            this.setState((prevState) => {
                if (prevState.retryCountdown <= 1) {
                    clearInterval(this.retryInterval);
                    window.location.reload(true);
                    return { retryCountdown: 0 };
                }
                return { retryCountdown: prevState.retryCountdown - 1 };
            });
        }, 1000);
    }

    componentWillMount () {
        this.formValidation = new FormValidation({
            component: this, validators: { 'formData.usuario': (v) => Validator.notEmpty(v), 'formData.clave': (v) => Validator.notEmpty(v) }
        });

        const customAppLogo = ConfigBusiness.get("frontend.logos.app");
        if (customAppLogo && customAppLogo !== "true" && customAppLogo !== "false") {
             this.setState({ logoLoginUrl: process.env.PUBLIC_URL + "/images/company/" + customAppLogo, loadingLogoLogin: false });
        } else {
            fetch(Config.get('apiUrlBase') + '/public/contextos_imagenes/logoLogin', { headers: { 'Accept': 'application/json' } })
            .then(res => {
                let cType = res.headers.get('Content-Type');
                if (cType && cType.startsWith('image/')) return res.blob();
                throw new Error('No img');
            })
            .then(blob => { this.setState({ logoLoginUrl: URL.createObjectURL(blob) }); })
            .catch(() => {})
            .finally(() => { this.setState({ loadingLogoLogin: false }); });
        }
    }

    componentDidMount () {
        document.body.className = 'vertical-layout vertical-menu 1-column menu-expanded blank-page blank-page';
        document.body.setAttribute('data-col', '1-column');

        if (!document.getElementById('devops-maint-style')) {
            const style = document.createElement('style');
            style.id = 'devops-maint-style';
            style.innerHTML = `
                .vec-loader { width: 100%; height: 6px; background: #f3f3f3; border-radius: 3px; overflow: hidden; margin: 15px 0 10px 0; position: relative;}
                .vec-progress { height: 100%; background: #00c0bd; transition: width 1s linear; }
                .car-icon { position: absolute; top: -20px; font-size: 22px; transition: left 1s linear; margin-left:-11px; }
                .car-flipped { display: inline-block; transform: scaleX(-1); }
            `;
            document.head.appendChild(style);
        }

        // --- PILDORATI CON ANIMACIÓN DE "DESPEGUE" ---
        if (!document.getElementById('devops-login-pill-style')) {
            const stylePill = document.createElement('style');
            stylePill.id = 'devops-login-pill-style';
            stylePill.innerHTML = `
                .v-pill-wrapper {
                    position: absolute;
                    bottom: 12px;
                    right: 20px; /* POSICION DERECHA INICIAL */
                    width: auto;
                    text-align: right;
                    pointer-events: none;
                    z-index: 5;
                    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                }
                .v-pill-wrapper.expanded-wrapper {
                    left: 50%;
                    transform: translateX(-50%); /* SALTO AL CENTRO */
                }
                .v-pill {
                    display: inline-block;
                    pointer-events: auto;
                    padding: 3px 12px;
                    background: #ffffff;
                    border: 1px solid #eee;
                    border-radius: 20px;
                    color: #bbb;
                    font-size: 10px;
                    font-weight: 700;
                    cursor: pointer;
                    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                    transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);
                    white-space: nowrap;
                    max-width: 85px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .v-pill.expanded {
                    max-width: 600px;
                    background: #00c0bd;
                    color: #ffffff;
                    border-color: #00c0bd;
                    transform: translateY(45px); /* SALIDA DE LA CARD */
                    box-shadow: 0 10px 20px rgba(0,192,189,0.3);
                }
                .v-pill:hover {
                    background: #fcfcfc;
                    color: #999;
                }
                .v-pill.expanded:hover {
                    background: #00b3b0;
                    color: #ffffff !important; /* TEXTO SIEMPRE BLANCO EN EXPANDIDO */
                }
            `;
            document.head.appendChild(stylePill);
        }

        if (this.state.mantenimientoEnabled === "true") {
            this.startMantenimientoController();
        }

        const hostname = window.location.hostname;
        if (hostname === 'telecom.vec.com.ar' || hostname === 'telecom.vecfleet.io' || hostname === 'testing-teco.vec.com.ar') {
            const target = hostname.includes('test') ? 'https://personal-test.vecfleet.io' : 'https://personal.vecfleet.io';
            this.setState({ isLegacyDomain: true, targetUrl: target });
            this.redirectInterval = setInterval(() => {
                this.setState((prevState) => {
                    if (prevState.countdown <= 1) { clearInterval(this.redirectInterval); window.location.replace(target); return { countdown: 0 }; }
                    return { countdown: prevState.countdown - 1 };
                });
            }, 1000);
        }

        fetch(Config.get('apiUrlBase') + '/public/auth/services', { headers: { 'Accept': 'application/json' } })
        .then(res => {
            if(res.status === 200) { res.json().then(data => { this.setState({ loginServices: data }) }); }
            else { this.setState({ configError: true }); this.startRetryCountdown(); }
        }).catch(() => {
            this.setState({ configError: true }); this.startRetryCountdown();
        }).finally(() => {
            this.setState({ loading: false });
            if (this.state.loginServices && (this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) && this.state.mantenimientoEnabled !== "true") {
                if(this.refs.usuario) this.refs.usuario.focus();
            }
        });

        try {
            const langJson = JSON.parse(ConfigBusiness.get("frontend.multilenguaje"));
            if (langJson) this.setState({ languages: langJson.map(e => { e.title = this.state.languagesExtra[e.lang]; return e; }) });
        } catch(e) {}
    }

    componentWillUnmount() {
        if (this.redirectInterval) clearInterval(this.redirectInterval);
        if (this.mantenimientoController) clearInterval(this.mantenimientoController);
        if (this.bgCheckInterval) clearInterval(this.bgCheckInterval);
        if (this.retryInterval) clearInterval(this.retryInterval);
    }

    handleFormChange(event) {
        const target = event.target;
        let formDataCopy = JSON.parse(JSON.stringify(this.state.formData));
        formDataCopy[target.name] = target.value;
        this.setState({ formData: formDataCopy, errors:[] });
    }

    handleSubmit(event) {
        this.setState({ loading: true, errors:[] });
        fetch(Config.get('apiUrlBase') + '/public/auth/login', {
            method: 'POST', headers: { 'Accept': 'application/json', 'Content-Type': 'application/json' },
            body: JSON.stringify({ ...this.state.formData }),
        }).then(response => {
            if(response.status === 200) {
                response.json().then(data => {
                    if(data && data.usuario && data.usuario.token) {
                        localStorage.setItem('persona', JSON.stringify(data));
                        localStorage.setItem('token', data.usuario.token);
                        localStorage.removeItem('eric:history');
                        localStorage.setItem('cerrarNotificacion', false);
                        var smsHabilitado = ConfigBusiness.get('2fa.sms.habilitado') === 'true';
                        var totpHabilitado = ConfigBusiness.get('2fa.totp.habilitado') === 'true';
                        var twofaHabilitado = smsHabilitado || totpHabilitado;

                        if (data.usuario.enable_twofa && twofaHabilitado) {
                            var metodo = data.usuario.twofa_metodo;
                            if (metodo === 'totp' && totpHabilitado) {
                                if (data.usuario.twofa_setup_complete) {
                                    this.setState({ redirectTo: '/auth/2fa-totp' });
                                } else {
                                    this.setState({ redirectTo: '/auth/2fa-totp-setup' });
                                }
                            } else if ((metodo === 'sms' || !metodo) && smsHabilitado) {
                                if (!data.celularCodArea || !data.celularNumero) {
                                    swal("Atención", "No se encontró celular para 2FA.", "error");
                                } else {
                                    this.setState({ redirectTo: '/auth/2fa' });
                                }
                            } else {
                                swal("Error", "Método 2FA no disponible. Contacte al administrador.", "error");
                            }
                        } else { window.location.reload(); }
                    } else { this.error(); }
                });
            } else if(response.status === 401) {
                response.json().then(data => { this.setState({ errors: data.detalle ||['login.errors.invalido'] }); }).catch(() => { this.setState({ errors:['login.errors.invalido'] }); });
            } else if(response.status === 400 || response.status === 403) {
                response.json().then(data => {
                    const msgKey = (data.detalle && data.detalle[0]) ? data.detalle[0] : 'errors.default';
                    this.setState({ errors:[msgKey] });
                });
            } else { this.error(); }
        }).catch(() => {
            this.error("Problema de conexión con el servidor.");
        }).finally(() => {
            this.setState({ loading: false });
        });

        event.preventDefault();
    }

    handleForgotPassword(e) { this.setState({ redirectTo: '/olvide-clave' }); e.preventDefault(); }
    changeLocale(locale) { localStorage.setItem('userLocale', locale); window.location.reload(); }
    error(customMsg = null) { swal("Error", customMsg || "Contacte al administrador.", "error"); }

    render() {
        this.formValidation.validate();
        let validationState = this.formValidation.state;
        if(!this.loginRandom) this.loginRandom = 1 + Math.floor((4 - 1) * Math.random());

        const logoAppSrc = this.state.logoLoginUrl || this.getBrandedLogo("logo-login-app.png");
        const logoCompanySrc = this.getBrandedLogo("logo-login-company.png", "frontend.logos.company.visible");
        const logoPoweredBySrc = this.getBrandedLogo("logo-login-powered-by.png", "frontend.logos.poweredBy.visible");

        const versionLabel = process.env.REACT_APP_VERSION || "0.0.0";
        const shortVersion = versionLabel.split('-')[0];
        const isVersionLong = versionLabel.length > 10;

        const progressPercent = ((this.state.mantenimientoIntervalo - this.state.mantenimientoTick) / this.state.mantenimientoIntervalo) * 100;
        const estimatedUptime = this.getEstimatedUptime();

        return (
            <React.Fragment>
                {ConfigBusiness.get("generales.alertaSuspension")==='true' && (
                    <Notificacion closeable={false} title="Aviso" message="Su cuenta tiene un pago pendiente." top="0" />
                )}
                {this.state.redirectTo && <Redirect push to={this.state.redirectTo} />}
                {this.state.loading && <Loading hideSpinner />}

                <div style={{ position: 'fixed', bottom: '15px', right: '20px', zIndex: 1000, opacity: 0.4, transition: 'opacity 0.2s', cursor: 'pointer' }}
                     onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                     onMouseLeave={(e) => e.currentTarget.style.opacity = 0.4}>
                    <a href="/salir" title={this.props.intl.formatMessage({id: 'login.clear_cache', defaultMessage: 'Limpiar Caché'})}>
                        <div className="bg-white rounded-circle shadow-sm border d-flex justify-content-center align-items-center" style={{width:'35px', height:'35px'}}>
                            <i className="la la-broom" style={{ fontSize: '18px', color: '#666' }}></i>
                        </div>
                    </a>
                </div>

                <div className="app-content content">
                    <div className="content-wrapper">
                        <div className="content-header row"></div>
                        <div className="content-body">

                            <video className="video-login-bg" autoPlay muted loop poster={process.env.PUBLIC_URL + "/images/images-login/image"+ this.loginRandom +".png"}>
                                <source src={process.env.PUBLIC_URL + "/images/videos-login/video"+ this.loginRandom +".mp4"} type="video/mp4"/>
                            </video>

                            <section className="flexbox-container">
                                <div className="col-12 d-flex align-items-center justify-content-center">
                                    <div className="col-11 col-sm-8 col-md-6 col-lg-4 p-0" style={{maxWidth: '400px', position: 'relative'}}>

                                        <div className="card border-0 m-0" style={{borderRadius: '1rem', boxShadow: '0 15px 35px rgba(0,0,0,0.2)', position: 'relative', overflow: 'visible'}}>

                                            <div id="loginLogo" className="card-header border-0 text-center pb-0" style={{paddingTop: '2rem'}}>
                                                {!this.state.loadingLogoLogin &&
                                                    <img
                                                        src={logoAppSrc}
                                                        alt="App Logo"
                                                        className="img-fluid center-block"
                                                        style={{ maxHeight: '100px', objectFit: 'contain', transition: 'all 0.3s ease' }}
                                                        onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-app.png"; }}
                                                    />
                                                }
                                            </div>

                                            <div className="card-body" style={{padding: '1.5rem 1.5rem 1rem', position: 'relative'}}>
                                                {this.state.configError ? (
                                                    <div className="text-center py-1">
                                                        <div className="mb-1"><i className="la la-exclamation-triangle" style={{ fontSize: '40px', color: '#dc3545' }}></i></div>
                                                        <h4 className="mb-2 text-danger font-weight-bold">Problemas de Conexión</h4>
                                                        <p className="text-muted" style={{fontSize: '13px'}}>No se pudo establecer comunicación con el servidor.<br/>Estamos intentando reconectar.</p>
                                                        <div className="mt-3"><div className="progress mb-2" style={{height: '5px', borderRadius:'5px'}}><div className="progress-bar bg-danger" role="progressbar" style={{width: (this.state.retryCountdown / 60 * 100) + '%'}}></div></div><small className="text-muted">Reintentando en {this.state.retryCountdown}s...</small></div>
                                                        <button className="btn btn-outline-danger btn-block mt-3 shadow-sm" onClick={() => window.location.reload(true)} style={{borderRadius: '8px'}}><i className="la la-refresh"></i> Reintentar Ahora</button>
                                                    </div>
                                                ) : this.state.mantenimientoEnabled === "true" ? (
                                                    <div className="text-center py-2 px-2">
                                                        <div className="mb-2"><i className="la la-cog spinner text-warning" style={{ fontSize: '45px' }}></i></div>
                                                        <h4 className="font-weight-bold mb-3"><FormattedMessage id="login.mantenimiento.titulo" defaultMessage="Plataforma en Mantenimiento" /></h4>
                                                        <div className="alert alert-warning border-0 p-3 mb-3 text-left" style={{borderRadius: '8px', fontSize: '13px', backgroundColor: '#fff8e1', color: '#856404'}}>
                                                            {this.state.mantenimientoMensaje.map((linea, idx) => (<p key={idx} className={idx === this.state.mantenimientoMensaje.length-1 ? "mb-0" : "mb-2"}>{linea}</p>))}
                                                        </div>
                                                        {this.state.mantenimientoModo === 'countdown' && (
                                                            <div className="mt-3">
                                                                <span className="badge badge-secondary p-2" style={{fontSize: '18px', fontFamily: 'monospace', borderRadius: '8px'}}>
                                                                    <i className="la la-clock-o"></i> {this.state.mantenimientoCountdownStr}
                                                                </span>
                                                                {estimatedUptime && (
                                                                    <div className="mt-2 text-muted" style={{fontSize: '10px', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '0.5px'}}>
                                                                        {estimatedUptime}
                                                                    </div>
                                                                )}
                                                                <button className="btn btn-outline-primary btn-sm btn-block shadow-sm mt-3" style={{borderRadius: '8px'}} onClick={() => window.location.reload(true)}>
                                                                    <i className="la la-refresh"></i> Reintento Manual
                                                                </button>
                                                            </div>
                                                        )}
                                                        {this.state.mantenimientoModo === 'retry' && (
                                                            <div className="mt-3 pt-2">
                                                                <div style={{position:'relative', width:'100%'}}>
                                                                    <div className="car-icon" style={{left: `${progressPercent}%`}}><span className="car-flipped">🚗</span></div>
                                                                </div>
                                                                <div className="vec-loader"><div className="vec-progress" style={{width: `${progressPercent}%`}}></div></div>
                                                                <p className="text-muted mt-2 mb-0" style={{fontSize: '13px'}}>Estamos preparando la flota...<br/><strong>Revalidando en {this.state.mantenimientoTick}s</strong></p>
                                                                <button className="btn btn-outline-primary btn-sm btn-block shadow-sm mt-3" style={{borderRadius: '8px'}} onClick={() => window.location.reload(true)}>
                                                                    <i className="la la-refresh"></i> Reintento Manual
                                                                </button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <div className="login-normal-flow mt-1">
                                                        {this.state.loginEnabled === "false" ? (
                                                            <div className="text-center py-3"><h4 className="text-muted font-weight-bold">Plataforma no disponible</h4><p className="text-muted mt-2" style={{fontSize:'13px'}}>Por favor, contacte a su Ejecutivo de Cuentas.</p></div>
                                                        ) : (
                                                            <React.Fragment>
                                                                {(this.state.loginServices.classic === 'true' || this.state.loginServices.classic === true) &&
                                                                    <form className="form-horizontal" noValidate ref="form" onSubmit={this.handleSubmit}>
                                                                        <fieldset className="form-group position-relative has-icon-left mb-2">
                                                                            <input type="text" className="form-control" style={{borderRadius: '8px', transition: 'border-color 0.2s', borderColor: this.state.focusUser ? '#0056b3' : '#d9d9d9', paddingLeft:'35px', height:'42px'}} name="usuario" ref="usuario" placeholder={this.props.intl.formatMessage({ id: 'login.usuario.placeholder', defaultMessage: 'Usuario' })} tabIndex="1" required="" onChange={this.handleFormChange} onFocus={() => this.setState({focusUser: true})} onBlur={() => this.setState({focusUser: false})} />
                                                                            <div className="form-control-position" style={{top:'1px'}}><i className="la la-user" style={{color: this.state.focusUser ? '#0056b3' : '#a1a1a1'}}></i></div>
                                                                        </fieldset>
                                                                        <fieldset className="form-group position-relative has-icon-left mb-1">
                                                                            <input type="password" className="form-control" style={{borderRadius: '8px', transition: 'border-color 0.2s', borderColor: this.state.focusPass ? '#0056b3' : '#d9d9d9', paddingLeft:'35px', height:'42px'}} name="clave" placeholder={this.props.intl.formatMessage({ id: 'login.contraseña.placeholder', defaultMessage: 'Contraseña' })} tabIndex="2" required onChange={this.handleFormChange} onFocus={() => this.setState({focusPass: true})} onBlur={() => this.setState({focusPass: false})} />
                                                                            <div className="form-control-position" style={{top:'1px'}}><i className="la la-key" style={{color: this.state.focusPass ? '#0056b3' : '#a1a1a1'}}></i></div>
                                                                        </fieldset>
                                                                        <div className="form-group row mb-2 mt-0">
                                                                            <div className="col-12 text-right">
                                                                                <button type="button" className="btn btn-link p-0 text-muted" style={{fontSize: '12px', textDecoration: 'none'}} onClick={e => this.handleForgotPassword(e)}><i className="ft-unlock"></i> <FormattedMessage id="login.contraseña.olvido" defaultMessage="¿Olvidó su contraseña?"/></button>
                                                                            </div>
                                                                        </div>
                                                                        <div className="text-center mb-2" hidden={this.state.errors.length===0} style={{minHeight:'18px'}}>
                                                                            <small className="text-danger font-weight-bold">
                                                                                {this.state.errors.map((e, i) => {
                                                                                    let msg = backendStrings[e] || FALLBACK_MESSAGES[e] || { id: 'error.generic', defaultMessage: e };
                                                                                    return <span key={i}><FormattedMessage {...msg}/> </span>
                                                                                })}
                                                                            </small>
                                                                        </div>
                                                                        <button type="submit" className="btn btn-primary btn-block shadow-sm" style={{borderRadius: '8px', height:'42px', fontWeight: '500', letterSpacing: '0.5px'}} disabled={!validationState.form.valid}>
                                                                            <i className={this.state.loading ? 'la la-spinner spinner' : 'la la-sign-in mr-1'}></i> <FormattedMessage id="login.ingresar" defaultMessage="Ingresar"/>
                                                                        </button>
                                                                    </form>
                                                                }

                                                                {(this.state.loginServices.google === 'true' || this.state.loginServices.google === true) &&
                                                                    <div className="mt-2">
                                                                        <a href={this.state.googleLoginRedirect} className="btn btn-outline-secondary btn-block bg-white shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '42px', color: '#555', textDecoration:'none', transition: 'background-color 0.2s'}} onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                            <img style={{width: '20px', marginRight: '10px'}} src={process.env.PUBLIC_URL + "/images/google.svg"} alt="G"/>
                                                                            <span className="font-weight-bold" style={{fontSize: '13px'}}><FormattedMessage id="login.google" defaultMessage="Ingresar con Google" /></span>
                                                                        </a>
                                                                    </div>
                                                                }
                                                                {(this.state.loginServices.azure === 'true' || this.state.loginServices.azure === true) &&
                                                                    <div className="mt-2">
                                                                        <a href={this.state.azureLoginRedirect} className="btn btn-outline-secondary btn-block bg-white shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '42px', color: '#555', textDecoration:'none', transition: 'background-color 0.2s'}} onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                            <img style={{width: '20px', marginRight: '10px'}} src={process.env.PUBLIC_URL + "/images/microsoft.svg"} alt="MS"/>
                                                                            <span className="font-weight-bold" style={{fontSize: '13px'}}><FormattedMessage id="login.microsoft" defaultMessage="Ingresar con Microsoft" /></span>
                                                                        </a>
                                                                    </div>
                                                                }
                                                                {(this.state.loginServices.okta === 'true' || this.state.loginServices.okta === true) &&
                                                                    <div className="mt-2">
                                                                        <a href={this.state.oktaLoginRedirect} className="btn btn-outline-secondary btn-block bg-white shadow-sm d-flex align-items-center justify-content-center" style={{borderRadius: '8px', height: '42px', color: '#555', textDecoration:'none', transition: 'background-color 0.2s'}} onMouseOver={e => e.currentTarget.style.backgroundColor = '#f8f9fa'} onMouseOut={e => e.currentTarget.style.backgroundColor = '#ffffff'}>
                                                                            <img style={{width: '20px', marginRight: '10px'}} src={process.env.PUBLIC_URL + "/images/okta.svg"} alt="Okta" onError={(e) => { e.target.style.display = 'none'; }}/>
                                                                            <span className="font-weight-bold" style={{fontSize: '13px'}}><FormattedMessage id="login.okta" defaultMessage="Ingresar con Okta" /></span>
                                                                        </a>
                                                                    </div>
                                                                }
                                                            </React.Fragment>
                                                        )}
                                                    </div>
                                                )}

                                                <div className="mt-4 pt-3" style={{borderTop: '1px solid #f3f3f3'}}>
                                                    <div className="row align-items-center">
                                                        <div className="col-6 text-left">
                                                            {logoCompanySrc && <img src={logoCompanySrc} alt="Company" className="img-fluid" style={{maxHeight: '40px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-company.png"; }} />}
                                                        </div>
                                                        <div className="col-6 text-right">
                                                            {logoPoweredBySrc && <img src={logoPoweredBySrc} alt="Powered By" className="img-fluid" style={{maxHeight: '35px', maxWidth: '100%', objectFit:'contain'}} onError={(e) => { e.target.onerror = null; e.target.src = process.env.PUBLIC_URL + "/images/company/logo-login-powered-by.png"; }} />}
                                                        </div>
                                                    </div>

                                                    <div className="text-center mt-3 d-flex justify-content-between align-items-center px-1">
                                                        <div className="d-flex">
                                                            {this.state.languages.map((elem,index) => (
                                                                <span key={index} onClick={() => this.changeLocale(elem.lang)} className="cursor-pointer mx-1" title={elem.title} style={{opacity: 0.8, transition: 'opacity 0.2s'}} onMouseEnter={e => e.currentTarget.style.opacity=1} onMouseLeave={e => e.currentTarget.style.opacity=0.8}>
                                                                    <img src={process.env.PUBLIC_URL + "/images/flags/" + elem.code + ".svg"} alt={elem.code} style={{width: '28px'}}/>
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* LA PÍLDORA MENAITO EDITION - AHORA CON CLASE CONDICIONAL EN EL WRAPPER */}
                                                <div className={"v-pill-wrapper " + (this.state.showVersionFull ? "expanded-wrapper" : "")}>
                                                    <span className={"v-pill " + (this.state.showVersionFull ? "expanded" : "")} onClick={() => isVersionLong && this.setState({ showVersionFull: !this.state.showVersionFull })}>
                                                        v{this.state.showVersionFull ? versionLabel : shortVersion} {isVersionLong && (this.state.showVersionFull ? "✖" : "▼")}
                                                    </span>
                                                </div>

                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default injectIntl(Login);
